export default __webpack_public_path__ + "static/media/ionic-eye.db6441dd.svg";